const pageTextConfig = {
  footerTab1: {
    fullName: {
      label: "Full Name",
      name: "fullName"
    },
    contactNo: {
      label: "Contact no.",
      name: "contactNo"
    },
    email: {
      label: "Email",
      name: "email"
    },
    message: {
      label: "Message",
      name: "message",
      helperText: "Let us know how we can help."
    },
  },
  footerTab2: {
    contact: {
      title: "Contact:",
      data: "+91-8368857097"
    },
    email: {
      title: "Email:",
      data: "info@geniegig.com"
    },
    address: {
      title: "Address:",
      data: "E-322, Tagore Garden Extension, New Delhi, Delhi 110027, India"
    },
    // info: "Sometimes, your call might connect directly to the customer care executive without IVR selection menu. We regret the inconvinience"
  }
}

export default pageTextConfig